<template>
  <div class="w-full h-full">
    <video
      data-test="video-preview"
      :src="src"
      class="w-full h-full rounded-8"
      muted
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  src: string
}>()
</script>
